/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocial_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontCallButton_viewer">;
    readonly " $refType": "StorefrontSocial_viewer";
};
export type StorefrontSocial_viewer$data = StorefrontSocial_viewer;
export type StorefrontSocial_viewer$key = {
    readonly " $data"?: StorefrontSocial_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontSocial_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '5d99f3cde3423e815e63e88579c0b4c1';
export default node;
